export function FilterIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 5.75C4.5 5.33579 4.80996 5 5.19231 5H15.8077C16.19 5 16.5 5.33579 16.5 5.75C16.5 6.16421 16.19 6.5 15.8077 6.5H5.19231C4.80996 6.5 4.5 6.16421 4.5 5.75Z"
      />
      <path d="M6.5 9.5C6.5 9.08579 6.7982 8.75 7.16606 8.75H13.8339C14.2018 8.75 14.5 9.08579 14.5 9.5C14.5 9.91421 14.2018 10.25 13.8339 10.25H7.16606C6.7982 10.25 6.5 9.91421 6.5 9.5Z" />
      <path d="M7.5 13.25C7.5 12.8358 7.83235 12.5 8.24232 12.5H12.7577C13.1677 12.5 13.5 12.8358 13.5 13.25C13.5 13.6642 13.1677 14 12.7577 14H8.24232C7.83235 14 7.5 13.6642 7.5 13.25Z" />
    </svg>
  );
}
